import { NAME as APP_NAME, ROUTES as DRIVERS_ROUTES } from '../constants';

export const NAME = `${APP_NAME}/DRIVER`;

export const REDUCER_NAME = 'drivers';

export const FORM_NAME = 'UPDATE_DRIVER_INFO';

export const ROUTES = {
  ROOT: `${DRIVERS_ROUTES.ROOT}/:driverId/update`,
};
